// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"Home_pageTitle__1a9uR","pageBlurb":"Home_pageBlurb__nk_eT","clientTitle":"Home_clientTitle__2u6sT","clientLogo":"Home_clientLogo__1ZtiN"};